import { useState } from "react";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import img from "../images/methanisation_centre.jpg";
import affiche from "../images/2.Pilotage.jpg";
import circlehydra from "../images/biomethane.png";
import photovoltaique from "../images/photovoltaique.png";
import drop from "../images/icons/drop.png";
import innovation from "../images/innovation.jpg";
import photovol from "../images/photovoltaique.jpg";

const Innovation = () => {
  const [toggle, setToggle] = useState("Biométhane");

  return (
    <div className="pl-8 pr-0 md:pl-16 md:pr-0 lg:pl-20 lg:pr-0">
      {/* Version responsive */}
      <div className="mb-10">
        {/* Layout pour écrans moyens et grands */}
        <div className="relative hidden w-full md:flex md:items-center md:justify-between">
          <div className="pl-0 pr-4 mt-20 sm:pl-0 sm:pr-6 lg:pl-0 lg:pr-8">
            <h1 className="text-xl font-bold text-black">Innovations</h1>
            <p className="mt-2 text-base">
              Innovations Durables pour un Avenir Plus Vert
            </p>
          </div>

          <div className="relative rounded-lg bg-primary">
            <div className="m-10 h-96 w-[700px]"></div>

            <img
              src={innovation}
              alt="Innovation"
              className="absolute right-[50px] top-1/2 transform -translate-y-1/2 z-10 rounded-xl w-full h-96 object-cover"
            />
          </div>
        </div>

        {/* Layout pour mobile */}
        <div className="flex flex-col w-full md:hidden">
          <div className="p-6 text-center">
            <h1 className="text-xl font-bold text-black">Innovations</h1>
            <p className="mt-2 text-base">
              Innovations Durables pour un Avenir Plus Vert
            </p>
          </div>

          <div className="relative mx-4 mb-6">
            <div className="p-4 rounded-lg bg-primary">
              <img
                src={innovation}
                alt="Innovation"
                className="object-cover w-full h-64 rounded-xl"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="mb-10">
        <h2 className="pt-10 pb-10 text-xl font-bold text-center text-black">
          Vers une Gestion Intelligente et Durable des Eaux Usées
        </h2>

        <div className="grid items-center justify-center grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="text-start">
            <h2 className="text-xl font-bold text-black">
              La valorisation des boues
            </h2>
            <p className="mt-2 text-base">
              Au cours des différentes étapes de traitement des eaux usées, des
              boues sont produites, récoltées et enfermées dans deux
              méthaniseurs. La méthanisation est un procédé anaérobie
              (c’est-à-dire en l’absence d’oxygène) naturel de transformation de
              la matière organique en énergie par des bactéries : c’est la
              chaleur et les conditions anaérobies qui permettent la
              prolifération de ces bactéries. Le biogaz produit sert en partie à
              l’alimentation électrique de l’usine. Déshydratées et enrichies
              avec de la chaux vive, les boues récupérées sont épandues dans les
              champs des environs. En valorisant cette matière, Hydreaulys
              poursuit une démarche environnementale à laquelle le syndicat est
              fermement attaché.
            </p>
          </div>

          <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
            <ReactPlayer
              playing={false}
              url="https://www.youtube.com/watch?v=UqIWjlTz7tE&embeds_referring_euri=https%3A%2F%2Fwww.eauxseineouest.fr%2F&source_ve_path=Mjg2NjY"
              width="100%"
              height="100%"
            />
          </div>
        </div>

        <div className="grid items-center justify-center grid-cols-1 mt-[5rem] md:grid-cols-2">
          <div className="flex-col justify-center ">
            <img
              src={affiche}
              alt="Hydreau 360 affiche"
              className="w-full h-auto max-w-lg rounded-lg"
            />
          </div>
          <div className="w-2/3 text-start">
            <h2 className="text-xl font-bold text-black">
              <span className="text-primary">Hydreau </span>360, l’outil de
              pilotage
            </h2>
            <p className="mt-2 text-base">
              Hydreau 360 intègre et agrège 70 000 données, produites en continu
              sur l’usine de traitement des eaux usées Carré de Réunion et ses
              réseaux, récoltées grâce à des capteurs et des sondes positionnés
              sur les ouvrages et les canalisations du système d’assainissement.
              Cet outil permet d’identifier tout type de dysfonctionnement afin
              d’anticiper et éviter les crises potentielles.
            </p>
          </div>
        </div>

        <div className="flex items-center justify-center gap-4 mt-6 sm:mt-20 sm:gap-6">
          <p
            onClick={() => setToggle("Biométhane")}
            className={`text-base cursor-pointer ${
              toggle === "Biométhane" ? "  font-bold" : ""
            }`}
          >
            Biométhane
            <hr
              className={`text-base cursor-pointer w-full ${
                toggle === "Biométhane"
                  ? "border-primary "
                  : "border-transparent"
              }`}
            />
          </p>
          <p
            onClick={() => setToggle("Photovoltaïques")}
            className={`text-base cursor-pointer ${
              toggle === "Photovoltaïques" ? " font-bold" : ""
            }`}
          >
            Photovoltaïques
            <hr
              className={`text-base cursor-pointer w-full ${
                toggle === "Photovoltaïques"
                  ? "border-primary "
                  : "border-transparent"
              }`}
            />
          </p>
        </div>
      </div>

      {toggle === "Biométhane" ? (
        <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
          <div className="grid justify-center grid-cols-1 mt-8 md:grid-cols-2">
            <div className="flex justify-center ">
              <img
                src={img}
                alt="Biométhane production"
                className="w-full h-auto max-w-lg rounded-lg"
              />
            </div>
            <div className="w-2/3 text-start">
              <h2 className="text-xl font-bold text-black">
                Les eaux usées deviennent une énergie 100 % renouvelable !
              </h2>
              <p className="mt-2 text-base">
                Le biométhane est un gaz vert produit à partir de la
                méthanisation des déchets des collectivités locales, agricoles
                ou encore issus des industries agro-alimentaires. La
                fermentation de ces déchets produit du biogaz qui, une fois
                épuré, est injecté dans le réseau de gaz naturel : c’est le
                biométhane, une version renouvelable non-fossile du gaz naturel
                et une source d’énergie qui peut en Europe contribuer à
                l’objectif de la transition énergétique avec moins d’émissions
                de gaz à effet de serre.
              </p>
            </div>
          </div>

          <div className="mt-20 text-xl font-bold text-center">
            Les Chiffres Clés de l’Énergie Renouvelable
          </div>
          <div className="p-4 mt-5 sm:p-6 bg-gradient-to-br">
            <div className="max-w-6xl mx-auto">
              <div className="text-center ">
                <div className="flex justify-center mb-4">
                  <div
                    className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                    style={{
                      mask: `url(${drop}) no-repeat center`,
                      maskSize: "contain",
                      WebkitMask: `url(${drop}) no-repeat center`,
                      WebkitMaskSize: "contain",
                    }}
                  />
                </div>
                <h2 className="mb-3 text-xl font-bold text-black">
                  Usine Carré de Réunion – <br />
                  Première en Île-de-France
                </h2>
                <div className="inline-block px-4 py-3 rounded-lg sm:px-6 text-primary">
                  <div className="text-base font-bold sm:text-lg">
                    Décembre 2019
                  </div>
                  <div className="text-base">
                    Première station d'épuration à
                  </div>
                  <div className="text-base">
                    produire du biogaz à partir des
                  </div>
                  <div className="text-base">eaux usées</div>
                </div>
              </div>

              <div className="grid items-center grid-cols-1 lg:grid-cols-3">
                <div className="space-y-6">
                  <div className="p-4 text-center sm:p-6">
                    <div
                      className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                      style={{
                        mask: `url(${drop}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${drop}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                    <h2 className="mb-3 text-xl font-semibold text-black">
                      Nombre de sites injectant du
                      <br />
                      biométhane (2024)
                    </h2>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      199 sites
                    </div>
                    <p className="text-base text-primary">
                      injectent du biométhane dans
                      <br />
                      les réseaux de gaz en France
                    </p>
                  </div>
                  <div className="p-4 text-center sm:p-6">
                    <div
                      className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                      style={{
                        mask: `url(${drop}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${drop}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                    <h3 className="mb-3 text-base font-semibold text-black">
                      Production totale de
                      <br />
                      biométhane
                    </h3>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      3 297 GWh/an
                    </div>
                    <p className="text-base text-primary">
                      Soit l'équivalent de la
                      <br />
                      consommation annuelle de
                      <br />
                      14 784 bus ou 549 500 foyers
                    </p>
                  </div>
                </div>

                <div className="flex justify-center">
                  <div className="relative">
                    <div className="relative w-48 h-48 overflow-hidden rounded-full sm:w-64 sm:h-64">
                      <img
                        src={circlehydra}
                        alt="Hydreaulys circular logo"
                        className="object-cover w-full h-full"
                      />
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="p-4 text-center sm:p-6">
                    <div
                      className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                      style={{
                        mask: `url(${drop}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${drop}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                    <h3 className="mb-3 text-base font-semibold text-black">
                      Objectif pour 2030
                    </h3>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      500 à 1 400 sites
                    </div>
                    <p className="text-base text-primary">
                      Prévision de développement de
                      <br />
                      nouveaux sites injecteurs de
                      <br />
                      biométhane
                    </p>
                  </div>
                  <div className="p-4 text-center sm:p-6">
                    <div
                      className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                      style={{
                        mask: `url(${drop}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${drop}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                    <h3 className="mb-3 text-base font-semibold text-black">
                      Méthaniseurs en service
                    </h3>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      2 méthaniseurs
                    </div>
                    <p className="text-base text-primary">
                      Transforment les boues issues
                      <br />
                      du traitement des eaux usées
                      <br />
                      en biogaz
                    </p>
                  </div>
                </div>
              </div>

              <div className="text-center ">
                <div className="inline-block p-4 sm:p-6">
                  <div
                    className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                    style={{
                      mask: `url(${drop}) no-repeat center`,
                      maskSize: "contain",
                      WebkitMask: `url(${drop}) no-repeat center`,
                      WebkitMaskSize: "contain",
                    }}
                  />
                  <h3 className="mb-3 text-base font-semibold text-black">
                    Production annuelle de biogaz
                    <br />
                    (2020)
                  </h3>
                  <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                    7 104 KWh
                  </div>
                  <p className="text-base text-primary">
                    Équivaut à :<br />
                    1 183 foyers ou 31 camions
                    <br />
                    roulant au BioGNV
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="grid items-center justify-center grid-cols-1 gap-6 mt-6 md:grid-cols-2">
            <div className="text-start">
              <p className="text-base">
                En valorisant cette matière,{" "}
                <span className="text-primary">Hydreaulys</span> poursuit une
                démarche environnementale à laquelle le syndicat est fermement
                attaché.
              </p>
            </div>

            <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
              <ReactPlayer
                playing={false}
                url="https://www.youtube.com/watch?v=WkKFutWqa4M&embeds_referring_euri=https%3A%2F%2Fwww.eauxseineouest.fr%2F&source_ve_path=Mjg2NjY"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="container px-4 mx-auto mt-20 mb-10 sm:px-6 lg:px-8">
          <div className="grid items-center justify-center grid-cols-1 mt-8 md:grid-cols-2">
            <div className="flex justify-center ">
              <img
                src={photovol}
                alt="Panneaux photovoltaïques"
                className="w-full h-auto max-w-lg rounded-lg"
              />
            </div>
            <div className="w-2/3 text-start">
              <h2 className="text-xl font-bold text-black">
                Panneaux Photovoltaïques
              </h2>
              <p className="mt-2 text-base">
                L’énergie photovoltaïque est l’un des principaux gisements et
                axe de développement des énergies renouvelables dans la
                politique énergétique française.
              </p>
            </div>
          </div>

          <div className="mt-20 text-xl font-bold text-center">
            L’Énergie Photovoltaïque en Quelques Données
          </div>
          <div className="p-4 mt-10 sm:p-6 bg-gradient-to-br">
            <div className="max-w-6xl mx-auto">
              <div className="mb-8 text-center">
                <div className="flex justify-center mb-4">
                  <div
                    className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                    style={{
                      mask: `url(${drop}) no-repeat center`,
                      maskSize: "contain",
                      WebkitMask: `url(${drop}) no-repeat center`,
                      WebkitMaskSize: "contain",
                    }}
                  />
                </div>
                <h2 className="mb-3 text-xl font-bold text-black">
                  Consommation Électrique <br />
                  de l’Usine (2019)
                </h2>
                <div className="inline-block px-4 py-3 rounded-lg sm:px-6 text-primary">
                  <div className="text-base font-bold sm:text-lg">19,3 GWh</div>
                  <div className="text-base">d’électricité consommée</div>
                </div>
                <div className="inline-block px-4 py-3 rounded-lg sm:px-6 text-primary">
                  <div className="text-base font-bold sm:text-lg">
                    Soit 2,2 MW
                  </div>
                  <div className="text-base">
                    de puissance moyenne instantanée
                  </div>
                </div>
              </div>

              <div className="grid items-center grid-cols-1 gap-6 lg:grid-cols-3">
                <div className="space-y-6">
                  <div className="p-4 text-center sm:p-6">
                    <div
                      className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                      style={{
                        mask: `url(${drop}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${drop}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                    <h2 className="mb-3 text-xl font-semibold text-black">
                      Installation Photovoltaïque
                    </h2>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      396 panneaux solaires
                    </div>
                    <p className="text-base text-primary">
                      Surface totale : 800 m²
                    </p>
                    <p className="text-base text-primary">
                      Implantés sur la toiture du bâtiment de filtration
                      membranaire
                    </p>
                  </div>
                </div>

                <div className="flex justify-center">
                  <div className="relative">
                    <div className="relative w-48 h-48 overflow-hidden rounded-full sm:w-64 sm:h-64">
                      <img
                        src={photovoltaique}
                        alt="Hydreaulys circular logo"
                        className="object-cover w-full h-full"
                      />
                    </div>
                  </div>
                </div>

                <div className="space-y-6">
                  <div className="p-4 text-center sm:p-6">
                    <div
                      className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                      style={{
                        mask: `url(${drop}) no-repeat center`,
                        maskSize: "contain",
                        WebkitMask: `url(${drop}) no-repeat center`,
                        WebkitMaskSize: "contain",
                      }}
                    />
                    <h2 className="mb-3 text-xl font-semibold text-black">
                      Production Solaire Annuelle
                    </h2>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      125 MWh/an
                    </div>
                    <p className="text-base text-primary">
                      de production estimée
                    </p>
                    <div className="mb-2 text-base font-bold sm:text-lg text-primary">
                      Soit 0,6 %
                    </div>
                    <p className="text-base text-primary">
                      de la consommation annuelle de l’usine
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center">
                <div className="inline-block p-4 sm:p-6">
                  <div
                    className="w-16 h-16 mx-auto mb-4 sm:w-20 sm:h-20 bg-primary"
                    style={{
                      mask: `url(${drop}) no-repeat center`,
                      maskSize: "contain",
                      WebkitMask: `url(${drop}) no-repeat center`,
                      WebkitMaskSize: "contain",
                    }}
                  />
                  <h3 className="mb-3 text-base font-semibold text-black">
                    Type d’utilisation
                  </h3>
                  <p className="text-base text-primary">
                    Autoconsommation directe
                    <br />
                    Sans stockage d’énergie
                  </p>
                </div>
              </div>
            </div>

            <div className="flex justify-center mt-20">
              <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
                <ReactPlayer
                  playing={false}
                  url="https://www.youtube.com/watch?v=WsukpYZckvg&embeds_referring_euri=https%3A%2F%2Fwww.eauxseineouest.fr%2F&source_ve_path=Mjg2NjY"
                  width="100%"
                  height="100%"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Innovation;
